import IconBorder from "src/shared/components/data-display/IconBorder/IconBorder"
import { Modal } from "src/shared/components/layout/modal/Modal"
import { Button } from "src/shared/components/forms"
import Icon from "src/shared/icons"
import { formatCurrency } from "src/shared/hooks/formatCurrency"

export type OperacionConfirmacion = {
    label: string
    monto: number
}

const ConfirmarCancelacion = ({
    isOpen,
    operaciones,
    motivo,
    loading,
    onConfirm,
    onClose,
}: {
    isOpen: boolean
    operaciones: OperacionConfirmacion[]
    motivo: string
    loading?: boolean
    onConfirm: () => void
    onClose: () => void
}) => {
    return (
        <Modal
            width={570}
            className="modal__confirmar-cancelacion"
            isOpen={isOpen}
            onClose={onClose}
            isCancelableOnClickOutside={false}
            withCloseButton
        >
            <div className="modal__confirmar-cancelacion__body">
                <IconBorder
                    primaryBgColor="#F6BEC3"
                    primaryBgDiameter={40}
                    secondaryBgColor="#FEF3F2"
                    secondaryBgDiameter={48}
                >
                    <Icon name="ExclamationFilled" color="#EB5757" width={20} height={20} />
                </IconBorder>
                <p className="modal__confirmar-cancelacion__title">¿Confirmas la cancelación?</p>
                <p className="modal__confirmar-cancelacion__description">
                    La cancelación de este movimiento restará el monto en el corte actual y, si aplica, también las
                    propinas asociadas. <b>Esta acción no se puede deshacer.</b>
                </p>
                <div className="modal__confirmar-cancelacion__section">
                    <p className="modal__confirmar-cancelacion__label">Operación</p>
                    {operaciones.map(({ label, monto }, index) => (
                        <div className="modal__confirmar-cancelacion__row" key={index}>
                            <span>{label}</span>
                            <b>{formatCurrency(monto)}</b>
                        </div>
                    ))}
                </div>
                <div className="modal__confirmar-cancelacion__section">
                    <p className="modal__confirmar-cancelacion__label">Motivo</p>
                    <span className="modal__confirmar-cancelacion__row">{motivo}</span>
                </div>
            </div>
            <div className="modal__confirmar-cancelacion__footer">
                <Button
                    theme="primary"
                    type="button"
                    text="Procesar cancelación"
                    className="modal__cancelar__button"
                    disabled={loading}
                    onClick={onConfirm}
                />
            </div>
        </Modal>
    )
}

export default ConfirmarCancelacion
